import { Link } from "react-router-dom";
import SwiperCore, { Navigation, Pagination, EffectFade } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import Skeleton from "react-loading-skeleton";
import { HiArrowLongRight } from "react-icons/hi2";
import { placeholderImage, translate } from "../utils";
import { AdSpace, ListItem, PanelHead, useSafeAutoplay } from "./SectionShared";
import "./pt-home.css";

SwiperCore.use([Navigation, Pagination, EffectFade]);

const stripHtml = (html = "") => String(html).replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ").trim();

/*
 Featured hero (bhagwa design):
   left  – full-image slider with title over the photo + Read More
   right – "Latest News" panel with saffron header, thumbnails and dates
*/
const StyleOne = ({ isLoading, Data, sideSection = null }) => {
    const news = Data?.news || [];
    const slides = news.slice(0, Math.min(3, news.length));
    const onSwiper = useSafeAutoplay(5000, slides.length > 1);
    if (!news.length) return null;

    // Right panel: Newspaper Coverage (if that section exists), otherwise Latest News
    const sideIsBreaking = !!sideSection && !sideSection.news?.length && !!sideSection.breaking_news?.length;
    const sideItems = sideSection ? (sideSection.news?.length ? sideSection.news : sideSection.breaking_news || []) : [];
    const latest = sideSection
        ? sideItems.slice(0, 4)
        : news.length > 4 ? news.slice(3, 8) : news.slice(1, 6);
    const sideTitle = sideSection ? stripHtml(sideSection.title || "Newspaper Coverage") : "Latest News";
    const sideViewAll = sideSection ? `/view-all/${sideSection.id}` : Data.id ? `/view-all/${Data.id}` : null;
    const sideLink = (item) =>
        sideIsBreaking ? `/breaking-news/${item.id}` : `/news/${item.id}/${item.category_id}`;

    const heroOptions = {
        loop: slides.length > 1,
        speed: 700,
        effect: "fade",
        fadeEffect: { crossFade: true },
        pagination: { clickable: true },
        navigation: slides.length > 1,
    };

    return (
        <div id="first-section" className="pt-hero-section">
            <AdSpace Data={Data} type="news" />
            <div className="container">
                <div className={`pt-hero-grid ${latest.length ? "" : "pt-hero-grid--single"}`}>
                    {/* Hero slider */}
                    <div className="pt-hero">
                        {isLoading ? (
                            <Skeleton height={380} />
                        ) : (
                            <Swiper {...heroOptions} onSwiper={onSwiper} className="pt-hero-swiper">
                                {slides.map((item) => {
                                    const title = stripHtml(item.title);
                                    return (
                                        <SwiperSlide key={item.id}>
                                            <Link to={`/news/${item.id}/${item.category_id}`} className="pt-hero-slide">
                                                <img src={item.image} alt={title || "Featured news"} onError={placeholderImage} />
                                                <span className="pt-hero-overlay" aria-hidden="true" />
                                                <span className="pt-hero-content">
                                                    <span className="pt-hero-badge">Featured News</span>
                                                    <span className="pt-hero-title">{title}</span>
                                                    {item.category_name ? (
                                                        <span className="pt-hero-sub">{item.category_name}</span>
                                                    ) : null}
                                                    <span className="pt-hero-btn">
                                                        {translate("readmore")} <HiArrowLongRight aria-hidden="true" />
                                                    </span>
                                                </span>
                                            </Link>
                                        </SwiperSlide>
                                    );
                                })}
                            </Swiper>
                        )}
                    </div>

                    {/* Latest News panel */}
                    {latest.length > 0 ? (
                        <aside className={`pt-panel pt-latest-side${sideSection ? " pt-side--newspaper" : ""}`}>
                            <PanelHead title={sideTitle} viewAllTo={sideViewAll} />
                            <div className="pt-panel-body">
                                {isLoading ? (
                                    <Skeleton height={70} count={4} />
                                ) : (
                                    <div className="pt-list">
                                        {latest.map((item) => (
                                            <ListItem
                                                key={item.id}
                                                to={sideLink(item)}
                                                image={item.image}
                                                title={item.title}
                                                date={item.date}
                                            />
                                        ))}
                                    </div>
                                )}
                            </div>
                        </aside>
                    ) : null}
                </div>
            </div>
        </div>
    );
};

export default StyleOne;
